import {connect, ConnectedProps} from 'react-redux';
import {withRouter} from 'react-router-dom';
import LeadImplantComponent from '../components/LeadImplantComponent';
import {RootState} from '../../../store';

const mapStateToProps = (state: RootState) => {
  return {
    isLogged: state.authReducer.isLogged,
    user: state.authReducer.user,
    patient: state.patientsReducer.patientInfo,
  }
}

const mapDispatchToProps = () => {
  return {}
}

const connector = connect(mapStateToProps, mapDispatchToProps)

export type PropsFromReduxLeadImplant = ConnectedProps<typeof connector> & {
  patientId?: number | undefined
  forceReload?: boolean
}

export default withRouter(connector(LeadImplantComponent) as any) as any as (props: {
  patientId?: number
  forceReload?: boolean
}) => JSX.Element
